import { render, staticRenderFns } from "./StatisticsMobile.vue?vue&type=template&id=21737f50"
import script from "./StatisticsMobile.vue?vue&type=script&lang=js"
export * from "./StatisticsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports